module.exports = __webpack_public_path__ + "img/trans_img.7f7f3fc9.png";